var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectorsInAct1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 9,
    viewBox: "0 0 17 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56_69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.6 -5.19416e-05H6.16C4.64 -0.0300519 3.32 1.48995 3.01 3.61995H0V5.06995H3C3.3 7.20995 4.63 8.72995 6.15 8.68995H7.59V-5.19416e-05H7.6Z",
    fill: "#33363F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.29 3.61997C12.99 1.48997 11.66 -0.0400271 10.13 -2.71086e-05H8.60999V8.68997H10.13C11.66 8.72997 12.98 7.20997 13.28 5.06997H16.21V3.61997H13.29Z",
    fill: "#33363F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56_69"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.21,
    height: 8.69,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectorsInAct1);
export default __webpack_public_path__ + "static/media/Connectors InAct 1.ce9c7abc07229ba4e4a961c90af5033f.svg";
export { ForwardRef as ReactComponent };